import nextId from "react-id-generator"
import quote from "../../images/double-quotes.svg"
import test1 from "../../images/test1.jpg"
import test2 from "../../images/test2.jpg"
import test3 from "../../images/test3.jpg"
import test4 from "../../images/test4.jpg"

export const slides = [
    {
        id: nextId(),
        quote: quote,
        description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officiis corrupti placeat quam soluta tempore vero, eaque nulla similique possimus aliquam rerum fuga eius aliquid est distinctio enim labore sit totam!",
        date: "July 05. 2022",
        image: test1,
        name: "John Doe",
        detail: "Director of a company"
    },
    {
        id: nextId(),
        quote: quote,
        description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officiis corrupti placeat quam soluta tempore vero, eaque nulla similique possimus aliquam rerum fuga eius aliquid est distinctio enim labore sit totam!",
        date: "July 05. 2022",
        image: test2,
        name: "John Doe",
        detail: "Director of a company"
    },
    {
        id: nextId(),
        quote: quote,
        description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officiis corrupti placeat quam soluta tempore vero, eaque nulla similique possimus aliquam rerum fuga eius aliquid est distinctio enim labore sit totam!",
        date: "July 05. 2022",
        image: test3,
        name: "John Doe",
        detail: "Director of a company"
    },
    {
        id: nextId(),
        quote: quote,
        description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officiis corrupti placeat quam soluta tempore vero, eaque nulla similique possimus aliquam rerum fuga eius aliquid est distinctio enim labore sit totam!",
        date: "July 05. 2022",
        image: test4,
        name: "John Doe",
        detail: "Director of a company"
    },
]